export default __webpack_public_path__ + "media/images/features/yado/facebook-097fac96e46a276d1fb445ce1a558ef2.png";